"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var mobx_react_1 = require("mobx-react");

var react_router_1 = require("react-router");

var react_1 = require("react");

var PantLogout = function PantLogout(props) {
  var sessState = props.appState.sessState;
  react_1.useEffect(function () {
    if (sessState.esLoginat) {
      sessState.reset();
    }
  }, []);
  return !!sessState.esLoginat && React.createElement(react_router_1.Redirect, {
    to: {
      pathname: '/login'
    }
  });
};

exports.default = mobx_react_1.inject('appState')(mobx_react_1.observer(PantLogout));